import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { DriverGroupsList } from "@lib/types/driver_group";

export const getDriverGroups = async (): Promise<DriverGroupsList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_DRIVER_GROUPS);
  return data;
};

export const getUnusedSlots = async (): Promise<string[]> => {
  const { data } = await axiosClient.get(
    `${ENDPOINTS.BASE_DRIVER}/unused-slots`
  );

  return data.map(String);
};
